import { render, staticRenderFns } from "./ProfileGearIcon.vue?vue&type=template&id=6aa43f5e&scoped=true"
import script from "./ProfileGearIcon.vue?vue&type=script&lang=js"
export * from "./ProfileGearIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa43f5e",
  null
  
)

export default component.exports